import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules'

function vh(v) {
    var h = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0,
    );
    return (v * h) / 100;
}

function vw(v) {
    var w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
    );
    return (v * w) / 100;
}

function vmin(v) {
    return Math.min(vh(v), vw(v));
}

export function initSwiper() {
    new Swiper('.swiper', {
        modules: [Pagination, Navigation],
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: vmin(1.5),
        breakpoints: {
            576: {
                slidesPerView: 2,
            },

            992: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
            disabledClass: 'swiper-disabled'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
}
